import React from "react";
import { defineMessages, useIntl } from "react-intl";

import { setInitialRequestorConfig } from "shared/lib/requestorFunctions";
import { formattedMessageParams } from "shared/messages";
// @ts-ignore
import Logger from "shared/services/Logger";

import PageSeo from "@components/Utils/PageSeo";

const { searchTitle, loginTitle } = defineMessages({
  searchTitle: formattedMessageParams("Iframe.title"),
  loginTitle: formattedMessageParams("Login.title"),
});

interface StateProps {
  showLoginIframeTitle: boolean;
}

type Props = StateProps;

function Iframe(props: Props): React.ReactElement | null {
  const { showLoginIframeTitle } = props;
  const intl = useIntl();

  // eslint-disable-next-line no-console
  return (
    <>
      <PageSeo
        title={{
          defaultTitle: intl.formatMessage(
            showLoginIframeTitle ? loginTitle : searchTitle
          ),
        }}
      />
      <style global jsx>{`
        html,
        body {
          background: transparent !important;
        }
      `}</style>
    </>
  );
}

Iframe.getInitialProps = async (initialProps) => {
  try {
    const { domain } = await setInitialRequestorConfig(initialProps);
    return { domain };
  } catch (e) {
    Logger.error(`Error Initial index: ${JSON.stringify(e)}`);
    return {};
  }
};

export default Iframe;
